<!-- Filter Navigation Bar -->
<app-common-page-breadcrumbs [pageTitle]="title" [navigationData]="navigationData"></app-common-page-breadcrumbs>
<div id="loader" *ngIf="enableLoader"></div>
<div *ngIf="!enableLoader">
<div class="filter-nav overflow-visible">
  <div class="container d-none d-lg-block">
     <div class="d-flex justify-content-between">
        <div class="d-flex">
        <div class="md-semibold-font text-black small p-2 text-nowrap">{{ 'home.productHeader.Filter' | cxTranslate }}</div>
          <div class="mr-2">
            <ng-select [items]="portData" [multiple]="true" [clearable]="false" bindLabel="name" dropdownPosition="bottom"
              groupBy="ports" [selectableGroup]="false" [closeOnSelect]="true"
              placeholder="{{'shipment.SelectPorts' | cxTranslate}}" bindValue="id" [(ngModel)]="selectedPort"
              [notFoundText]="'shipment.NoItemsFound' | cxTranslate" (change)="changePorts()">  
              <ng-template ng-multi-label-tmp>
                <span class="filter-count pl-2 text-black">{{selectedPort?.length}}x{{ 'shipment.Ports' | cxTranslate
                  }}</span>
              </ng-template>
              <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index" class="dropdown-ng-template">
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                <div (pointerdown)="getPortFacets(item)">
                  <input *ngIf="item.name!==undefined && item.name!==''" id="{{item.id}}" type="checkbox"
                    [ngModel]="item$.selected" [checked]="item.selected" /> <span>{{item.name}}</span>
                </div>
              </ng-template>
            </ng-select>
          </div>
            <div class="mr-2">
            <ng-select [items]="StatusList" [multiple]="true" [clearable]="false" bindLabel="name" dropdownPosition="bottom"
              groupBy="StatusList" [selectableGroup]="false" [closeOnSelect]="true" placeholder="{{'shipment.SelectStatus' | cxTranslate}}"
              bindValue="code" [(ngModel)]="selectedStatus" [notFoundText]="'shipment.NoItemsFound' | cxTranslate"
              (change)="changeStatus()">
              <ng-template ng-multi-label-tmp>
                <span class="filter-count pl-2 text-black">{{selectedStatus?.length}}x {{'shipment.statusselected' | cxTranslate}}</span>
              </ng-template>
              <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">
                <input type="checkbox" /><span class="ff-semibold "> {{'shipment.status' | cxTranslate}}</span>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                <div>
                <input *ngIf="item.name!==undefined && item.name!==''" id="{{item.code}}" type="checkbox"
                  [ngModel]="item$.selected" [checked]="item.selected" /> <span>{{item.name}}</span>
             </div>
                </ng-template>
            </ng-select>
          </div>
          <div *ngIf="showClear">
            <button type="button" class="btn btn-warning clear-text " (click)="clearAllFilter()">{{
              'home.productHeader.ClearFilter' | cxTranslate }}</button>
          </div> 
      </div>
   

      <!-- Export Button -->
      <div class="ml-auto d-flex">
        <button type="button" class="btn btn-secondary d-none d-sm-block mx-2" (click)="donwloadReport('quality_report')">
          <img src="./images/download_report.svg" alt="export" width="20px" height="20px">
          &nbsp; Export
        </button>
        <div class="search-section-div mx-2">
            <div class="input-group d-flex align-items-center">
              <input class="form-control form-control-lg border rounded-pill input-field" type="search"
                (keypress)="omitSpecialChar($event)" [(ngModel)]="searchText" (input)="search()"
                placeholder="{{ 'home.productHeader.Search' | cxTranslate }}">
              <span class="input-group-append">
                <button name='searchbuttondesktop'
                  class="btn btnUpgrade rounded-pill border-0 input-field bg-white border-start-0 border-bottom-0 border ms-n5"
                  type="button">
                  <i class="fa fa-search pe-none"></i>
                </button>
              </span>
            </div>
          </div>
      </div>
    </div>
  </div>

  <!-- Mobile Filter and Export -->
  <div class="container d-lg-none">
      <div class="row">
          <div class="w-100">
            <div class="filter-select-div-mobile pl-4">
                <div class="input-group align-items-center">
                  <input class="form-control border rounded-pill input-field" type="search" (input)="search()"
                    (keypress)="omitSpecialChar($event)" [(ngModel)]="searchText" placeholder="{{'shipment.search' | cxTranslate}}">
                  <span class="input-group-append d-flex align-items-center">
                    <button name='searchbuttonfilter' class="
                            btn
                            btnUpgrade
                            border-0
                            input-field
                            border-start-0 border-bottom-0 border
                            ms-n5
                          " type="button">
                    <i class="fa fa-search mobbar"></i>
                  </button>
              <span class="mx-2 line" ></span>
                  <div class="ml-1 dropdown show">
                    <button type="button"  (click)="donwloadReport('quality_report')" style="min-height: auto;"
                      class="float-right btn btn-sm btn-secondary" href="#" role="button"
                      id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><img
                        src="/images/download_report.svg" alt="customlogo" width="25px" height="25px">
                      </button>
                    
                  </div>
                  <!-- Add vertical divider between export and filter -->
                  <span class="mx-2 line"></span>
                  <div class='hidden-xs-filter-bar pr-1 ml-1' (click)='filtersidebar()'>
                    <img class="ml-1" src="./images/filternew.svg"><sup class="pl-2 pr-2 pt-1 pb-1"
                      *ngIf='length'>{{length}}</sup>
                    <div class="ff-semibold fs-10 d-flex align-items-center text-black Filternew">{{ 'home.filter.filters' |
                      cxTranslate }}</div>
                  </div>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="">
        <div [ngClass]="sidebar ?'hide-mobile-filter-sidebar': 'mobile-filter-sidebar' "
          class="hidden-xs-filter-bar sidebar">
          <div class='sticky-top  d-flex justify-content-between p-3 border sticky'>
            <div class="fs-24 md-semibold-font pl-1">{{ 'home.productHeader.Filter' | cxTranslate }}:</div>
            <div (click)="closebar()"><img src="/images/sidebarcross.svg" alt=""> </div>
          </div>
          <div class="scrollbar">
            <div>
              <div class="d-flex md-semibold-font small pl-3 pt-3 pb-2">{{'shipment.ports' | cxTranslate}} :</div>
              <div *ngFor="let ports of portData; let i=index" class="ml-5 small d-flex line-height">
                <label class="ff-normal" *ngIf="ports.name!==undefined && ports.name!==''">
                  <input type="checkbox" [(ngModel)]="ports.selected" [value]="ports.id"
                    [checked]="ports.selected" (change)="portsmobileFilter($event, ports.id)" />
                  {{ports.name}}
                </label>
              </div>
            </div>
              <div>
              <div class="d-flex md-semibold-font small pl-3 pt-3 pb-2">{{'shipment.status' | cxTranslate}} :</div>
              <div *ngFor="let status of StatusList; let i=index" class="ml-5 small d-flex line-height">
                <label class="ff-normal" *ngIf="status.name!==undefined && status.name!==''">
                  <input type="checkbox" [(ngModel)]="status.selected" [value]="status.code"
                    [checked]="status.selected" (change)="statusmobileFilter($event, status.code)" />
                  {{status.name}}
                </label>
              </div>
            </div>
            
          </div>
          <div class="sticky-bottom p-4 border-top">
            <button class="btn btn-block btn-primary w-100" (click)="getResults()">{{ 'home.contracts.seeResults'|cxTranslate}}</button>
            <button class='btn btn-block' (click)="clearFilterDataMobile($event);closebar()">{{ 'home.contracts.clearFilter' |
              cxTranslate}}</button>
          </div>
        </div>
      </div>
      <!-- <div class="w-100 px-3 py-2">
        <div class="d-flex gap-2">
          <div class="flex-grow-1">
            <ng-select [items]="portList" bindLabel="name" bindValue="id" [placeholder]="'shipment.SelectPort' | cxTranslate"
              [(ngModel)]="selectedPort" (change)="onPortChange()" class="port-select-mobile">
            </ng-select>
          </div>
          <button type="button" class="btn btn-sm btn-secondary" (click)="onExport()">
            <img src="/images/download_report.svg" alt="export" width="18px" height="18px">
          </button>
        </div>
      </div> -->
    
  </div>
</div>

<!-- Tabs -->
<div class="container">
  <div class="row d-flex justify-content-between px-2 pt-4">
    <div class="col-lg-2 tabDiv">
      <nav class="product-tab ">
        <div class="nav nav-fill nav-tabs pe-auto" id="nav-tab" role="tablist">
          <div class="nav-item nav-link active tab-bar strong fs-14" [class.active]="activeTab === 'Active'"
            id="nav-profile-tab" data-toggle="tab" role="tab" aria-controls="nav-profile" aria-selected="true"
            (click)="switchTab('Active')"> {{'shipment.Active' | cxTranslate}}
          </div>
          <div class="nav-item nav-link  tab-bar strong fs-14" [class.active]="activeTab === 'Completed'"
            id="nav-home-tab" data-toggle="tab" role="tab" aria-controls="nav-home" aria-selected="false"
            (click)="switchTab('Completed')">{{'shipment.Completed' | cxTranslate}}
          </div>
        </div>
      </nav>
    </div>

  </div>
</div>
<div class="container " *ngIf="(activeTab==='Active' || activeTab === 'Completed') && !enableLoader" infiniteScroll
  [infiniteScrollDistance]="1" [infiniteScrollThrottle]="50" (scrolled)="onScrollGrid()" [scrollWindow]="true"
  [infiniteScrollDisabled]="reachedToEnd === true">
  <div *ngIf="inspectionData && inspectionData.length === 0 && !enableLoader "
    class="text-center strong  text-secondary my-5">
    {{'home.contracts.Noresults' | cxTranslate }}</div>
  <!-- <div
    *ngIf="inspectionData && inspectionData.length === 0 && !enableLoader "
    class="text-center strong  text-secondary my-5">
    {{'home.contracts.Noresults' | cxTranslate }}</div> -->

  <!-- Items List -->


  <div class="col-md-12 col-lg-12 " *ngFor="let data of inspectionData">
    <div class="card mt-4 mb-4 card-border border-radius-05">
      <div *ngIf="data.status == 'NEW' || data.status == 'ASSIGNED' || data.status == 'INPROGRESS' || data.status == 'COMPLETED' || data.status == 'ARCHIVED'"
        [ngStyle]="{'background-color': data.status == 'NEW' ? '#0A6CB4' : data.status == 'ASSIGNED' ? '#06AD96' : data.status == 'INPROGRESS' ? '#E87202' : data.status == 'COMPLETED' ? '#6C757D' : '#131313'}"
        class="card-header borderRadius pb-1"
        [ngClass]="{'pl-2': data.status == 'COMPLETED' || data.status == 'ARCHIVED'}">
        <div class='d-flex justify-content-between'>
          <div class=""><span class="mr-1"><img class="mb-1" src="./images/ship.svg" alt="icon" width="35"
                height="20"></span><span>{{data.batchId}}</span></div>
          <div class="d-flex justify-content-between ">
             <span class="mr-3 d-none d-md-block d-lg-block ">{{ 'home.quote.Creationdate' | cxTranslate }} {{convertDateOnly(data.creationDate)}}</span>
            <div class="badge ml-auto fs-12 h-75" [ngClass]="{'badge-light': data.status == 'NEW', 'badge-indigo': data.status == 'ASSIGNED', 'badge-blue': data.status == 'INPROGRESS', 'badge-completed': data.status == 'COMPLETED' || data.status == 'ARCHIVED'}">{{data.statusLocale}}</div>
          </div>
        </div>
      </div>

      <div class="card-body d-none d-lg-block">
        <div class='d-flex py-2 text-break'>
          <div class=col-md-4>
            <div class="row">
 <div class="pl-1 d-none d-md-block d-lg-block col-md-8">
            <div class="h5 mb-0 fw-bold">{{data.vesselName?data.vesselName:'--'}}</div>
            <div class="small text-secondary">{{data.port?data.port:'--'}}</div>
          </div>
          <div class="d-none d-md-block d-lg-block col-md-4">
             <div class="small text-secondary">{{'shipment.qualityInsp.TotalInspectedQty' | cxTranslate}}</div>
            <div class="small text-black">{{data.formattedTotalInspectedQty?data.formattedTotalInspectedQty:'--'}}</div>
          </div>
            </div>

          </div>
         
          <div class="col-md-8">
            <div class="row">
<div class="col-md-8">
                <div class="row">
               <div class="d-none d-md-block d-lg-block col-md-2 ">
                <div class="small text-secondary">{{'shipment.qualityInsp.NBSLFE' | cxTranslate}}</div>
                <div class="small text-black fs-12">{{data.formattedLumpFe?data.formattedLumpFe:'--'}}</div>
              </div>
               <div class="d-none d-md-block d-lg-block col-md-2 ">
                <div class="small text-secondary">{{'shipment.qualityInsp.NBSLH20' | cxTranslate}}</div>
                <div class="small text-black fs-12">{{data.formattedLumpH2o?data.formattedLumpH2o:'--'}}</div>
              </div>
               <div class="d-none d-md-block d-lg-block col-md-2 p-0">
                <div class="small text-secondary">{{'shipment.qualityInsp.NBSL63mm' | cxTranslate}}</div>
                <div class="small text-black fs-12">{{data.formattedLumpMinus6p3Mm?data.formattedLumpMinus6p3Mm:'--'}}</div>
              </div>
               <div class="d-none d-md-block d-lg-block col-md-2 ">
                <div class="small text-secondary">{{'shipment.qualityInsp.NBSFFE' | cxTranslate}}</div>
                <div class="small text-black fs-12">{{data.formattedFineFe?data.formattedFineFe:'--'}}</div>
              </div>
               <div class="d-none d-md-block d-lg-block col-md-2">
                <div class="small text-secondary">{{'shipment.qualityInsp.NBSFH20' | cxTranslate}}</div>
                <div class="small text-black fs-12">{{data.formattedFineH2o?data.formattedFineH2o:'--'}}</div>
              </div>
              <div class="d-none d-md-block d-lg-block col-md-2 p-0">
                <div class="small text-secondary">{{'shipment.qualityInsp.NBSF63mm' | cxTranslate}}</div>
                <div class="small text-black fs-12">{{data.formattedFinePlus6p3Mm?data.formattedFinePlus6p3Mm:'--'}}</div>
              </div>
            </div>
            </div>
            <div class="col-md-4">
       <div class="d-none d-md-block d-lg-block col-md-12">
            <div class="small  text-secondary">{{'batches.inspection_agent' | cxTranslate}}</div>
            <div class="small text-black fs-12">{{data.agent?data.agent:'--'}}</div>
          </div>
            </div>
            </div>
            
            
          </div>
      

        </div>
      </div>
      <!-- Mobile view INPROGRESS/completed tab-->
      <div class="py-4 d-lg-none">
       <span class="ml-2 text-secondary small ">{{ 'home.quote.Creationdate' | cxTranslate }} {{convertDateOnly(data.creationDate)}}</span>
        <div class="ml-2 d-flex justify-content-between">
          <div class="h6 ml-2 mb-0 fw-bold">{{data.vesselName?data.vesselName:'--'}}</div>
          <div class="small mr-3 text-secondary">{{data.port?data.port:'--'}}</div>
        </div>
      </div>
      <!-- End  -->
      <!-- Mobile View Active/Completed tab -->
      <div class="hr mt-0 mb-0 d-lg-none"></div>
      <div class="py-2 d-lg-none">
        <div class="d-flex mb-3 col mt-2 justify-content-between">
          <div class="small strong text-secondary">{{'shipment.qualityInsp.TotalInspectedQty' | cxTranslate}}</div>
          <div class="small text-black">{{data.formattedTotalInspectedQty?data.formattedTotalInspectedQty:'--'}}</div>
        </div>
        <div class="d-flex mb-3 col justify-content-between">
          <div class="small strong text-secondary">{{'shipment.qualityInsp.NBSLFE' | cxTranslate}}</div>
          <div class="small text-black">{{data.formattedLumpFe?data.formattedLumpFe:'--'}}</div>
        </div>
        <div class="d-flex mb-3 col justify-content-between">
          <div class="small strong text-secondary">{{'shipment.qualityInsp.NBSLH20' | cxTranslate}}</div>
          <div class="small text-black">{{data.formattedLumpH2o?data.formattedLumpH2o:'--'}}</div>
        </div>
        <div class="d-flex mb-3 col justify-content-between">
          <div class="small strong text-secondary">{{'shipment.qualityInsp.NBSL63mm' | cxTranslate}}</div>
          <div class="small text-black">{{data.formattedLumpMinus6p3Mm?data.formattedLumpMinus6p3Mm:'--'}}</div>
        </div>
        <div class="d-flex mb-3 col justify-content-between">
          <div class="small strong text-secondary">{{'shipment.qualityInsp.NBSFFE' | cxTranslate}}</div>
          <div class="small text-black">{{data.formattedFineFe?data.formattedFineFe:'--'}}</div>
        </div>
        <div class="d-flex mb-3 col justify-content-between">
          <div class="small strong text-secondary">{{'shipment.qualityInsp.NBSFH20' | cxTranslate}}</div>
          <div class="small text-black">{{data.formattedFineH2o?data.formattedFineH2o:'--'}}</div>
        </div>
        <div class="d-flex mb-3 col justify-content-between">
          <div class="small strong text-secondary">{{'shipment.qualityInsp.NBSF63mm' | cxTranslate}}</div>
          <div class="small text-black">{{data.formattedFinePlus6p3Mm?data.formattedFinePlus6p3Mm:'--'}}</div>
        </div>
        <div class="d-flex mb-3 col justify-content-between">
          <div class="small strong text-secondary">{{'batches.inspection_agent' | cxTranslate}}</div>
          <div class="small text-black">{{data.agent?data.agent:'--'}}</div>
        </div>
      </div>

      <!-- End Mobile view  -->
      <div class="hr mt-0 mb-2"></div>
         
      <div class=" ml-2 mb-2 row justify-content-between ">
        <div class=" col-md-3  mt-2 ml-1">
          <div class="strong text-primary pe-auto" (click)="gotoDetails(data,'view')">
            {{'shipment.Viewdetails' | cxTranslate}} ></div>
        </div>
        <div class="d-flex flex-column flex-lg-row align-items-start align-items-lg-center col-12 col-lg-auto ml-lg-auto mr-lg-5 small text-secondary mt-2 mt-lg-0">
                    <div class="mr-lg-4 mb-1 mb-lg-0">
                      <span>{{'batches.cargoagent' | cxTranslate}}:</span>
                      <span class="text-blue text-decoration-underline pe-auto ml-2"
                        (click)="openCargoAgentPopup('cargo_agent', data)">{{data.cargoAgent?.name ? data.cargoAgent?.name : 'Unassigned'}}</span>
                    </div>
                    <div>
                      <span>{{'batches.screening_operator' | cxTranslate}}:</span>
                      <span class="text-blue text-decoration-underline pe-auto ml-2"
                        (click)="openCargoAgentPopup('screening_operator', data)">{{data.screeningAgent?.name ? data.screeningAgent?.name : 'Unassigned'}}</span>
                    </div>
                    <div class="ml-4">
                        <div *ngIf="(data?.status == 'COMPLETED')" class="justify-content-end">
                        <button *ngIf="isAgentInvoiceActive=== 'true'"
                            class="btn btn-sm strong text-primary btn-light border rounded btnheight pl-5 pr-5 bg-transparent"
                            (click)="openInvoices(data)">{{'shipment.invoice.attachInvoice' |
                            cxTranslate}}</button>
                  </div>
                  </div>
                  
      </div>
      
    </div>
  </div>
</div>
</div>